// import components
import {
  styled,
  Box,
  TextField,
  TextFieldProps,
  BoxProps,
  Button,
  ButtonProps
} from '@mui/material';

// import types
import { SliderMaxHoursBoxProps } from './SourceCard.types';

export const StyledSourceCardBox = styled(Box)<BoxProps>(({ theme }) => ({
  border: `1px dashed ${theme.palette.primary.main}`,
  padding: theme.spacing(8, 7),
  backgroundColor: theme.vars.palette.surface.container,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(4),
  '&:last-child': {
    marginBottom: 0
  }
}));

export const StyledHoursBox = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'end'
}));

export const StyledTopInformationBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  height: theme.spacing(13),
  marginBottom: theme.spacing(4)
}));

export const StyledHoursTextField = styled(TextField)<TextFieldProps>(
  ({ theme }) => ({
    width: theme.spacing(20)
  })
);

export const StyledSliderMaxHoursBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'maxSliderHours'
})<SliderMaxHoursBoxProps>(({ theme, maxSliderHours }) => ({
  marginLeft: theme.spacing(4),
  fontSize: theme.typography.htmlFontSize,
  fontFamily: 'SourceSansPro-Bold',
  color: maxSliderHours ? theme.palette.text.disabled : 'inherit'
}));

export const StyledSourceCardButton = styled(Button)<ButtonProps>(
  ({ theme }) => ({
    marginLeft: theme.spacing(4)
  })
);
